export const ALL = 'all';
export const FAVORITE = 'favorites';
export const ARCHIVE = 'archive';
